export default __webpack_public_path__ + "static/media/image-earphones-yx1.8c249446.jpg";